/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {stubbifyPrivacyRequest} from '../api'

export const useMutationStubbifyPrivacyRequest = createReactQueryMutationHook('stubbifyPrivacyRequest', stubbifyPrivacyRequest)
